// services/personal.service.ts
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Experience } from '../store/experience/experience.state'
import { eps } from './url.service'

@Injectable({ providedIn: 'root' })
export class ExperienceService {
  private apiUrl = eps.experience.experienceApi

  constructor(private http: HttpClient) {}

  getExperiences(
    params: string | null,
    page: number | null | undefined,
    limit: number | null | undefined
  ): Observable<{ experiences: Experience[]; totalExperienceYears: number }> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<{ experiences: Experience[]; totalExperienceYears: number }>(url)
  }

  createExperience(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}`, payload)
  }

  updateExperience(id: string, payload: any): Observable<Experience> {
    return this.http.put<Experience>(`${this.apiUrl}/${id}`, payload)
  }

  deleteExperience(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {})
  }
}
